// extracted by mini-css-extract-plugin
export var cardHeader = "_te-0";
export var reorderHandle = "_te-3";
export var titleArea = "_te-1";
export var titleAreaWithHandle = "_te-2";